/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, array_unique, elementHasClassName, htmlspecialchars, mj_deep_extend, copyToClipboard } from './util.js';
import { postToBackend, postToBackend2, default_ajax_app_error_handler } from './fetch-util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { closeDialog, scrollElementIntoView } from './dialog-util.js';
import { confirm_box } from './page-modal.js';
import { showInfoToastWithLink, showInfoToast, showWarningToast } from './snackbar.js';

import { MPlugins } from './plugins.js';
import { MDLocale } from './locale-impl.js';

import { MDMeta } from './meta-data.js';
import { MDMedia } from './media-data.js';
import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';

import { ACLEdit } from './acls.js';
import { MVCompare } from './compare.js';
import { MVDownload } from './download.js';
import { Lightbox } from './lightbox.js';
import { MVMediaMetaBatchProcessing } from './media-meta-batch-processing.js';
import { MPreviewUtil } from './media-preview-util.js';
import { MValueLists } from './meta-value-lists.js';
import { MVSend } from './send.js';
import { MVPublish } from './publish.js';
import { MVPrint } from './print.js';
import { MVExport } from './export.js';
import { MVDownloadInfo } from './download-info.js';
import { MVBulkPermissions } from './bulk-perms.js';
import { MVMediaMetadata } from './media-data-view.js';
import { MVMediaMetadataEditWidgets } from './media-data-edit-widgets.js';


import { delete_media, maintenance_post_import_media, maintenance_update_media, maintenance_re_import_media } from './media-page-actions.js';


export let MVDetail = function($,mj) {

	var md_canvas,						// #md-canvas
		md_annotations_canvas,			// #md-annotations-canvas
		md_canvases,					// #md-canvas,#md-annotations-canvas
		m_open_close_transition_active = false,
		m_mode = 'detail',
		// data of all opened media
		m_mids = [],
		// data of currently displayed media
		m_midx = 0,
		m_media_id = 0,
		m_dtinfo = null,
		m_redt_count = null, // number of media from m_mids on which the user has edit permissions
		// function - when called, it will re-open the detail view with ids from a superior media id list
		m_superior_media_id_list_cb = null,
		// additional preview options
		m_preview_xopts = {},
		// original dialog dimensions, on creation
		md_dlg_w = 550,
		md_dlg_h = 550;

	let m_tmp_mids_b4del_order = {};

	// if set, then this one will be used on mjswinresize events, otherwise "switch_mode()" will be called
	let m_resize_handler = function() {
		switch_mode(m_mode);
	};

	const m_preview_loader = MPreviewUtil.createMediaPreviewLoader(0);

	let m_toolbar_ot_init_done = false;
	let m_tb_hover_off_timeout_id = null;

	let m_last_data_request = null;


	function abort_current_data_request() {
		if( typeof m_last_data_request === 'undefined' ) return;
		if( m_last_data_request!==null && m_last_data_request.state && m_last_data_request.state()==='pending' ) {
			// ABORT pending request
			m_last_data_request.abort();
			m_last_data_request = null;
		}
	}


	function get_cur_canvas() {
		if( m_mode==='detail' ) return md_canvas;
		else if( m_mode==='annotations' ) return md_annotations_canvas;
		return null;
	}



	function resize_canvas( w, h, stopped ) {
		if( m_mode==='annotations' ) {
			if( stopped ) md_annotations_canvas.triggerHandler( 'mjsresize', [w,h] );
		} else {
			md_canvas.css( { width:w+'px', height:h+'px' } );
			if( stopped ) md_canvas.triggerHandler( 'mjsresize', [w,h] );
		}
	}

	function switch_mode( mode, meta_loaded_cb ) {
		if( mode != m_mode ) {
			// reset canvas & toolbar
			m_preview_loader.removePreview();
		}

		let _on_resize;
		m_mode = mode;
		m_resize_handler = function() {
			switch_mode(m_mode);
		};

		$('#md-media,#md-versions,#md-acl,#md-acl-info,#md-annotations').hide();
		$('#md-form').closest('.ui-dialog').find('> .ui-dialog-titlebar > .ui-dialog-title').mjDialogTabs('activate',m_mode);

		const cfg_min_data_w = 200;
		let cfg_min_view_w = 130;

		if( mode==='detail' ) {
			const md_band = $('#md-band');

			// show/hide and position page elements
			_on_resize = function( stopped, save ) {
				let md_view_w=md_dlg_w-450+395+6+4;
				let md_view_h=md_dlg_h-102;
				const max_data_w=md_dlg_w-450+398-cfg_min_view_w;
				if( $('#md-data-col').css('display')==='none' ) {
					// show canvas only
					$('#md-toolbar').css('width',(md_view_w+22)+'px').find('td.buttons').css('padding-right','65px');
					md_band.css({left:'auto',right:'0px'}).addClass('closed');
					resize_canvas(md_view_w+20,md_view_h+20,stopped);
					if( save ) setInSession('media_detail_data_opened','0');
				} else {
					// show canvas + data
					$('#md-data-col').resizable('option','maxWidth',max_data_w);
					let data_w = $('#md-data-col').width()||0;
					if( data_w > max_data_w ) {
						data_w = max_data_w;
						$('#md-data-col').css('width',data_w+'px');
					}
					md_view_w -= data_w-2;
					resize_canvas(md_view_w+20,md_view_h+20,stopped);
					$('#md-data-col').css({height:'',left:''}); // remove height & left styles (was added by "ui resizable", but leads to problems)
					$('#md-toolbar').css('width',(md_view_w+22)+'px').find('td.buttons').css('padding-right','0px');
					md_band.css({left:(md_view_w+23)+'px',right:'auto'}).removeClass('closed');
					if( save ) setInSession({'media_detail_data_opened':'1','media_detail_data_width':Math.round(data_w)});
				}
			};
			md_band.off().click( function(e) {
				$('#md-data-col').toggle();
				_on_resize(true,true);
			} )
				.show();
			md_band.on( 'contextmenu', function() {
				return false;
			} );
			if( md_band.length ) {
				md_band[0].onselectstart = function() {
					return false;
				};
			}

			let md_data_col_last_resizable_stop_ts = null;
			$('#md-data-col')
				.resizable('destroy')
				.toggle( getFromSession('media_detail_data_opened','1')=='1' )
				.css( 'width', getFromSession('media_detail_data_width','398')+'px' )
				.resizable(
					{
						handles:	'w',
						minWidth:	cfg_min_data_w,
						start:		function(evt,ui) {
							// temporarily disable pointer events on iframes...
							md_canvas.find('iframe').css('pointer-events','none');
						},
						resize:		function(evt,ui) {
							_on_resize(false,false);
						},
						stop:		function(evt,ui) {
							md_data_col_last_resizable_stop_ts=evt.timeStamp;
							_on_resize(true,true);
							// re-enable pointer events on iframes...
							md_canvas.find('iframe').css('pointer-events','auto');
						},
					}
				);
			$('#md-data-col').children('.ui-resizable-handle.ui-resizable-w').on('click',function(e) {
				if( e.timeStamp - (md_data_col_last_resizable_stop_ts||0) > 200 ) {
					md_band.triggerHandler('click');
					return false;
				}
			});
			_on_resize(true,false);
			m_resize_handler = function() {
				_on_resize(true,false);
			};

			// show dialog inner div
			$('#md-media').show();

			// show data of selected file
			switch_view( m_midx, false, meta_loaded_cb );

		} else if( mode==='annotations' ) {

			const md_annotations_toolbar = $('#md-annotations-toolbar');
			md_annotations_toolbar.css({zIndex:10001}).show();

			// TODO: this is just a quick & dirty hack ...
			// clicking left or right edge of toolbar will make it stick to either left or right side of
			// the viewport
			const dpr = md_annotations_toolbar.data('pos-right');
			if( !dpr ) {
				let rv = $.style(md_annotations_toolbar[0],'right');
				if( rv==='auto' ) rv = '';
				md_annotations_toolbar.data('pos-right',rv);
			}

			md_annotations_toolbar.find('td.top-edge,td.left-edge,td.right-edge,td.bottom-edge')
				.addClass('link')
				.off('click.MVDetail').on('click.MVDetail', function() {
					// toggle 'right' style prop between 'auto' and the value it had initially
					const rv = $.style(md_annotations_toolbar[0],'right');
					md_annotations_toolbar.css({ right: rv==='auto' ? md_annotations_toolbar.data('pos-right') : 'auto' });
				});


			_on_resize = function( stopped, save ) {
				const w = md_annotations_canvas.width();
				const h = md_annotations_canvas.height();
				resize_canvas(w,h,stopped);
			};

			// show dialog inner div
			$('#md-annotations').show();

			_on_resize(true,false);
			m_resize_handler = function() {
				_on_resize(true,false);
			};

			// show data of selected file
			switch_view( m_midx, false, meta_loaded_cb );

		} else if( mode==='versions' ) {
			const md_versions_band = $('#md-versions-band');

			switch_canvas();
			const resize_version_list = function( w, h, stopped ) {
				$('#md-versions-list').css( { width:w+'px', height:h+'px' } );
				if( stopped ) $('#md-versions-list').triggerHandler( 'mjsresize', [w,h] );
			};
			// show/hide and position page elements
			cfg_min_view_w = 350;
			_on_resize = function( stopped, save ) {
				let md_view_w=md_dlg_w-450+395+6;
				let md_view_h=md_dlg_h-62;
				const max_data_w=md_dlg_w-450+398-cfg_min_view_w;
				if( $('#md-versions-data-col').css('display')=='none' ) {
					// show canvas only
					md_versions_band.css('left',(md_view_w+29)+'px').addClass('closed');
					resize_version_list(md_view_w+20,md_view_h+20,stopped);
					if( save ) setInSession('media_detail_version_data_opened','0');
				} else {
					// show canvas + data
					$('#md-versions-data-col').resizable('option','maxWidth',max_data_w);
					let data_w = $('#md-versions-data-col').width()||0;
					if( data_w > max_data_w ) {
						data_w = max_data_w;
						$('#md-versions-data-col').css('width',data_w+'px');
					}
					md_view_w -= data_w-2;
					resize_version_list(md_view_w+20,md_view_h+20,stopped);
					$('#md-versions-data-col').css({height:'',left:''}); // remove height & left styles (was added by "ui resizable", but leads to problems)
					md_versions_band.css('left',(md_view_w+27)+'px').removeClass('closed');
					if( save ) setInSession({'media_detail_version_data_opened':'1','media_detail_version_data_width':Math.round(data_w)});
				}
			};
			md_versions_band.off().click( function(e) {
				$('#md-versions-data-col').toggle();
				_on_resize(true,true);
			} )
				.show();
			md_versions_band.on( 'contextmenu', function() {
				return false;
			} );
			if( md_versions_band.length ) {
				md_versions_band[0].onselectstart = function() {
					return false;
				};
			}

			let md_versions_col_last_resizable_stop_ts = null;
			$('#md-versions-data-col')
				.resizable('destroy')
				.toggle( getFromSession('media_detail_version_data_opened','1')=='1' )
				.css( 'width', getFromSession('media_detail_version_data_width','398')+'px' )
				.resizable( {
					handles:	'w',
					minWidth:	cfg_min_data_w,
					start:		function(evt,ui) { },
					resize:		function(evt,ui) {
						_on_resize(false,false);
					},
					stop:		function(evt,ui) {
						md_versions_col_last_resizable_stop_ts=evt.timeStamp;
						_on_resize(true,true);
					},
				} );
			$('#md-versions-data-col').children('.ui-resizable-handle.ui-resizable-w').on('click',function(e) {
				if( e.timeStamp - (md_versions_col_last_resizable_stop_ts||0) > 200 ) {
					md_versions_band.triggerHandler('click');
					return false;
				}
			});
			_on_resize(true,false);
			m_resize_handler = function() {
				_on_resize(true,false);
			};

			MVMediaMetadata.setupMetadataView( $('#md-versions-data'), function() {
				// show dialog inner div
				$('#md-versions').show();
				// show data of selected file
				switch_view( m_midx, false, meta_loaded_cb );
			}, 'versions_' );

		} else if( mode==='acl' ) {

			// show/hide and position page elements
			switch_canvas();
			_on_resize = function( stopped, save ) {
				$('#md-acl').css( { height:(md_dlg_h-39)+'px' } ).show();
				if( md_dlg_w - 753 > 10 ) $('#md-acl-info').css( { width:(md_dlg_w-753)+'px', height:(md_dlg_h-39)+'px' } ).show();
			};
			$('#md-acl-all').hide();
			// configure acl-edit
			ACLEdit.configure(
				mj.trees[1].nodes,
				false,
				function( acl_id, cat_id, mid ) {			// = ACLEdit.m_load_acl_cb
					$('#md-acl-all').hide();
					$('#md-acl-thumbnail').empty();
					$('#md-acl-info-data').empty();
					if( cat_id && !mid ) {
						// editing a category -> no media, no data
						$('#acl-info').append( '<span style="font-weight:bold; color:#CD0707"><br />'+mjt('md-note-edit-cat-acl')+'<br /></span>' );
						$('<span class="emph-link" tabindex="0">'+mjt('md-edit-media-acl')+'</span>').click( function() {
							ACLEdit.load_acl(0,0,m_media_id);
						} ).appendTo( '#acl-info' );
					} else {
						// editing a media -> show media preview, show data
						let iwidth = Math.round( (md_dlg_w-773-20-100) / 2 );
						let floating = false;////iwidth > 150;
						if( !floating ) iwidth = iwidth*2-10;
						if( iwidth > 10 && m_media_id==mid ) {
							// add preview image
							if( iwidth > 320 ) iwidth = 320;
							const iheight = iwidth;
							const md_acl_thumb = $('#md-acl-thumbnail').css({float:floating?'right':'none',width:iwidth+'px',height:iheight+'px'});
							MThumbnails.createOnTarget(
								md_acl_thumb[0],
								{
									media_id: m_media_id,
									width: iwidth,
									height: iheight,
									thumb_loader_anim: true,
								}
							);
							// add data
							const trg = $('#md-acl-info-data');
							$('#md-data_common > div.content tr')
								.each( function() {
									const tr = $(this);
									const meta_id = tr.data('meta_id');
									const metaDisplayHtml = MVMediaMetadata.getInteractiveDisplayData(m_dtinfo.meta[meta_id]||[],meta_id);
									if( metaDisplayHtml!='' ) {
										trg
											.append('<b>'+tr.children('th').html()+'</b>')
											.append(MVMediaMetadata.wrapWithMetaDataHolder(meta_id,metaDisplayHtml+'&nbsp;',!!tr.data('list')));
									}
								} );
						}
						// fuer alle uebernehmen button
						if( m_mids.length>1 ) {
							$('#md-acl-all')
								.off()
								.click( function() {
									confirm_box( mjt('md-acl-all-confirm-title'), mjt('md-acl-all-confirm-message'), function() {
										let to_ids=[];
										const ml = m_mids.length;
										for( var idx=0; idx<ml; ++idx ) {
											if( m_mids[idx]!=m_media_id ) to_ids.push(m_mids[idx]);
										}
										startProgress();
										postToBackend('json/administration/acls-copy', 'from_media_id='+m_media_id+'&to_media_ids='+encodeURIComponent(to_ids.join(',')), function(j) {
											j ? showInfoToast(mjt('md-acl-all-done')) : showWarningToast(mjt('acl-edit-error'));
											stopProgress();
										});
									} );
								} )
								.show();
						}
					}
				},
				function( mid ) {								// = ACLEdit.m_media_info_cb
					if( mid==m_media_id ) {
						const t = m_dtinfo.meta[101] && m_dtinfo.meta[101][0] ? ( m_dtinfo.meta[101][0] + ' (ID ' + mid + ')' ) : mid;
						const c = m_dtinfo.categories['1'] || [];
						return { title:t, cat_id:c.length?c[0]:0 };
					}
				},
				function( cat_id, noCallEvent ) {				// = ACLEdit.m_select_cat_tree_node_cb
					// unused
				}
			);
			_on_resize(true,false);
			m_resize_handler = function() {
				_on_resize(true,false);
			};

			// show data of selected file
			switch_view( m_midx, false, meta_loaded_cb );
		}

	}

	function handle_escape_key( evt ) {
		let is_default_prevented = evt.isDefaultPrevented();
		if( is_default_prevented && evt.target && elementHasClassName(evt.target,'ui-dialog') && evt.target.parentElement!==null ) {
			is_default_prevented = false;
		}
		if( !is_default_prevented ) {
			evt.preventDefault();
			if( $('#mdu_upload_box').is(':visible') ) {
				reset_media_upload_widget();
				evt.stopPropagation();
			} else if( $('#cpu_upload_swf').is(':visible') ) {
				const tr = $('#cpu_upload_swf').closest('tr');
				const th = tr.find('th:first');
				if( th.next('td').children('.data-holder').css('display')==='none' ) {
					close_edit(tr);
					evt.stopPropagation();
				}
			} else if( window.MVPageDebug && window.MVPageDebug.isVisible() ) {
				const evtDoc = evt.target ? evt.target.ownerDocument : null;
				const canvasDoc = md_canvases.length ? md_canvases[0].ownerDocument : null;
				if( evtDoc===canvasDoc ) {
					// HACK: let dprints keydown handler handle this
					return false;
				}
				// HACK: close dprint ..
				window.MVPageDebug.close();
			} else {
				const edit_forms = $('#md-data .edit-item-form, #md-data .edit-group-form');
				if( edit_forms.length ) {
					edit_forms.first().find('.edit-buttons button.cancel, .edit-group-buttons button.cancel').trigger('click');
					evt.stopPropagation();
				} else if( closeDialog( $('#md-form'), false, evt ) ) {
					evt.stopPropagation();
					return true;
				}
			}
		}
		return false;
	}

	function switch_view( index, delta, meta_loaded_cb ) {
		// console.log({w:'switch_view',index,delta,meta_loaded_cb});

		if( m_mids.length===0 ) return;
		if( delta ) index = m_midx + index;
		if( index<0 ) index = m_mids.length-1;
		else if( index>=m_mids.length ) index = 0;
		m_midx = index;
		m_media_id = m_mids[m_midx];

		reset_dlg_tabs_status();

		if( !m_media_id ) return;

		// set numbers
		$('#md-id').text( m_media_id );
		let info_str = '';
		if( m_mids.length>1 ) {
			// set click handlers
			$('#md-empty-icon').hide().closest('.dlg-tab-nav').removeClass('tab-is-empty');
			$('#md-prev-icon')
				.show()
				.off()
				.mousedown(function(e) {
					// avoid dialog-dragging on button
					e.stopPropagation();
				})
				.click( function() {
					switch_view(-1,true);
				} );
			$('#md-next-icon')
				.show()
				.off()
				.mousedown(function(e) {
					// avoid dialog-dragging on button
					e.stopPropagation();
				})
				.click( function() {
					switch_view(+1,true);
				} );
			// build info string
			info_str = mjt('md-file').replace('%1',index+1).replace('%2',m_mids.length);
		} else {
			// one single file opened:
			$('#md-empty-icon').show().closest('.dlg-tab-nav').addClass('tab-is-empty');
			$('#md-prev-icon').hide();
			$('#md-next-icon').hide();
			// if a superior list (search result or lightbox) is available, then allow switching to that list...
			if( m_superior_media_id_list_cb ) {
				m_open_close_transition_active = false;
				m_superior_media_id_list_cb();
				// m_superior_media_id_list_cb( function _done_cb() {
				// 	console.log({w:'m_superior_media_id_list_cb -> done_cb'});
				// } );
				return;
			}
		}
		$('#md-info').text(info_str);

		$(document).off('keydown.MVDetail');

		let dtinfo_load_complete = null;

		if( m_mode==='detail' || m_mode==='annotations' || m_mode==='acl' ) {

			// enter loading state
			if( m_mode==='detail' ) $('#md-data').addClass('loading');

			// load meta- & auxiliary data
			dtinfo_load_complete = function _dtinfo_load_complete1() {
				if( m_mode==='detail' || m_mode==='annotations' ) {
					switch_canvas();
					const tbs = get_toolbar_selector();
					$(tbs+' .mdb-delete-i').toggle(!!m_dtinfo.r_delete);
					$(tbs+' .mdb-upload-i').toggle(!!m_dtinfo.r_edit);
					$(tbs+' .mdb-download-i').toggle(!!m_dtinfo.r_download);
					$(tbs+' .mdb-lb-in-i').toggle( Lightbox.isEnabled() && Lightbox.isEditable() );

					if( (mj.media_page_embed_mode??false)!==false ) {

						$(tbs).find('.mdb-link-i,.mdb-send-i,.mdb-publish-i,.mdb-export-i,.mdb-print-i,.mdb-delete-i,.mdb-upload-i,.mdb-advanced-i').remove();

					}

					if( m_mode==='detail' ) {
						switch_data();
					}
				} else if( m_mode==='acl' ) {
					ACLEdit.load_acl(0,0,m_media_id);
				}
				$(document).on('keydown.MVDetail', function( evt ) {
					// ignore keydown if other dialogs are opened
					if( $('#mv-compare-form,#mmbp-form,#mdli-form,#mxp-form,#mpub-form,#msslb-form,#ms-form,#mdl-form,#mp-form,#confirm-box,#error-box,#info-box,#mvl-values,div.colorpicker,span.select2-container--open').is(':visible') ) return true;
					// ignore keydown on input elements
					if( $('#md-form').is(':visible') ) {
						const focused_input = $('#md-form :focus').filter(':input').not('[type=file],button.iconic,button.muw-button');
						if( focused_input.length ) return true;
					}
					// ignore alt+meta+(*) combinations (these may be used for tab navigation on OSX...)
					if( evt.altKey && evt.metaKey ) return true;
					// handle navigation keys
					switch( evt.which ) {
					case 37: // LEFT
						if( m_mids.length===1 && m_superior_media_id_list_cb ) {
							m_superior_media_id_list_cb( function() {
								switch_view(-1,true);
							} );
						} else {
							switch_view(-1,true);
						}
						return false;
					case 39: // RIGHT
						if( m_mids.length===1 && m_superior_media_id_list_cb ) {
							m_superior_media_id_list_cb( function() {
								switch_view(+1,true);
							} );
						} else {
							switch_view(+1,true);
						}
						return false;
					case 27: // ESCAPE
						handle_escape_key(evt);
						return !evt.isPropagationStopped();
					}
				} );
			};

		} else if( m_mode==='versions' ) {

			const md_versions_list = $('#md-versions-list');
			const md_versions_data = $('#md-versions-data');
			let md_latest_version_number = null;
			let md_selected_version_number = null;

			const tpl_node = $('#md-template-version-item');

			// remove preview items from list view
			tpl_node.siblings().remove();

			// enter loading state
			md_versions_data.addClass('loading');

			dtinfo_load_complete = function _dtinfo_load_complete1_for_versions() {

				// add event handlers
				function mdd_select_version( version, silent ) {
					if( md_selected_version_number!==null && version===md_selected_version_number ) return; // no change
					md_selected_version_number = version;
					if( version!==null ) {
						// select given version number, so it becomes the actual list entry
						const sel_node = md_versions_list
							.children('.md-version-list-item').removeClass('selected')
							.filter('[mj_version='+version+']').addClass('selected');
						// scroll into view
						scrollElementIntoView( sel_node, md_versions_list );
					}
					// enter loading state
					if( !silent ) md_versions_data.addClass('loading');
					// query & show detail data for the selection version
					abort_current_data_request();
					m_last_data_request = MDMedia.queryMediaDetailVersionInfo( m_media_id, version, function( dtinfo ) {
						const is_latest_version = md_latest_version_number!==null && version==md_latest_version_number;
						const xv_dtinfo = { meta:(dtinfo.meta||{'-1':[0]}), categories:(dtinfo.categories||{}), is_latest_version:is_latest_version, r_edit:false };
						MVMediaMetadata.setupMetadataViewData( md_versions_data, m_media_id, xv_dtinfo, false, false, function container_cb( container, rows, can_edit ) {
							close_edit_group(container,rows);
							container.find('>.title>.edit-group').hide();
							rows.children('th').css('cursor','').off('click');
						} );
					}, default_ajax_app_error_handler, silent, true );
				}

				md_versions_list
					.off('click')
					.on('click','.md-version-list-item',function(ev) {
						mdd_select_version( $(this).attr('mj_version'), false );
					})
					.on('click','.md-version-list-item > .item-actions > .md-version-download-link',function(ev) {
						const item = $(this).closest('.md-version-list-item');
						const version = item.attr('mj_version');
						// select version row first ..
						mdd_select_version(version,false);
						// then continue with anchors default click handlers ..
					})
					.on('click','.md-version-list-item > .item-actions > .md-version-promote-button',function(ev) {
						const item = $(this).closest('.md-version-list-item');
						const version = item.attr('mj_version');
						const comment = 'restored from version '+version;
						mdd_select_version(version,false);

						confirm_box(mjt('md-version-confirm-promote-title'),mjt('md-version-confirm-promote-message'),function() {
							startProgress();
							postToBackend( 'json/media/version-promote', 'media_id='+encodeURIComponent(m_media_id)+'&version='+version+'&comment='+encodeURIComponent(comment), function(j) {
								stopProgress();
								if( j && j.success ) {
									showInfoToast(mjt('md-version-info-promote-succeeded').replace('%1',version));
									MDMedia.invalidateMediaCaches([m_media_id]);
									// wait until the file is ready for previewing ...
									// eslint-disable-next-line no-unused-vars
									let timeout_id = 0;
									const _go = function() {
										const postdata = 'media_id='+encodeURIComponent(m_media_id)+'&meta_ids='+encodeURIComponent(mj.required_thumbnail_meta_ids.join(','));
										postToBackend2( 'json/widgets/meta-media_thumb_info', postdata, function(xj) {
											if( xj && ( xj.available || xj.error ) ) {
												// update detail view, done ...
												stopProgress();
												switch_mode( 'detail', function() {
													// notify observers on meta & category changes
													trigger_full_meta_changed();
													// re-create thumbnails in all views
													$(document).triggerHandler('mjsrecreatethumbnails',[m_media_id,m_dtinfo.meta]);
												});
											} else {
												// retry
												timeout_id = setTimeout( _go, 1500 );
											}
										}, function() {
											// timeout handler - try again later
											timeout_id = setTimeout( _go, 2250 );
										} );
									};
									startProgress();
									_go();
								}
							}, true );
						});
					})
					.on('click','.md-version-list-item > .item-actions > .md-version-compare-button',function(ev) {
						const item = $(this).closest('.md-version-list-item');
						const version = item.attr('mj_version');
						mdd_select_version(version,false);
						MVCompare.selectItem(m_media_id,version,true);
					});

				// get & show list of available versions
				let req_list_meta_ids = [1];
				tpl_node.find('>.item-info [meta_id]').each(function(idx,elm) {
					req_list_meta_ids.push($(this).attr('meta_id'));
				});
				req_list_meta_ids = array_unique( [...mj.required_thumbnail_meta_ids,...req_list_meta_ids] );

				startProgress();
				abort_current_data_request();
				m_last_data_request = postToBackend( 'json/media/version-list', 'media_id='+encodeURIComponent(m_media_id)+'&meta_ids='+encodeURIComponent(req_list_meta_ids.join(',')), function(j) {
					stopProgress();

					const versions = j && j.hasOwnProperty('versions') ? j.versions : [];		// = reversed array(versionNo,versionNo,...) where idx=0 contains the LATEST versions version number
					if( versions.length ) {
						const data_versions = j.data_versions ?? [];
						const vmeta = j.meta;				// = metadata array, indexed by version
						const r_download = j.r_download;
						const r_edit = j.r_edit;

						let createThumbnailList = [];
						for( var i=0; i<versions.length; ++i ) {
							const version = versions[i];
							const meta = vmeta[version]||{'-1':[0]};
							const ena_dl_btn = (mj.role_versions_user||mj.role_versions_manager) && r_download;
							const ena_pr_btn = i>0 && mj.role_versions_manager && r_edit;

							const dl_fn = meta[1]&&meta[1][0]?meta[1][0]:'unknown';
							const dl_url = mj.fixAssetURL(mj.webroot+'media/file/download/format/0/id/'+m_media_id.toString()+'/fn/'+encodeURIComponent(dl_fn)+'?'+encodeURIComponent(Date.now())+'&version='+version);

							const is_data_version = arr_inArray(version,data_versions)!==-1;

							const node = tpl_node.clone(true)
								.attr( {
									id: 'md-version-list-item-'+version,
									mj_idx: i,
									mj_version: version,
									mj_filename: dl_fn,
									mj_dl_url: dl_url,
									is_data_version
								} )
								.find('>.item-info [meta_id]')
								.each( function(idx,elm) {
									const self = $(this);
									const meta_id = self.attr('meta_id');
									const data = meta[meta_id]||[];
									const data_html = MDMeta.getDisplayData(data,meta_id,false,{applyPlugins:true,pluginLinks:true});
									self.html(data_html);
									if( meta_id==15 && data_html==='' ) {
										self.parent().addClass('empty');
									}
								} )
								.end()
								.children('.item-actions')
								.children('.md-version-download-button').prop('disabled',!ena_dl_btn).end()
								.children('.md-version-promote-button').prop('disabled',!ena_pr_btn).end()
								.end()
								.toggleClass('is-data-version',is_data_version)
								.toggleClass('is-non-data-version',!is_data_version)
								.show()
								.appendTo(md_versions_list);

							// wrap anchor around button to improve download ux
							if( ena_dl_btn ) node.find('.md-version-download-button').wrap( $('<a>',{ href:dl_url, target:'_parent', download:dl_fn, 'class':'md-version-download-link' }) );
							createThumbnailList.push([version,node.children('.item-thumb')[0],is_data_version]);
						}

						if( createThumbnailList.length ) {
							const createNextThumbnail = function( ctListIdx, deferNextUntilImgLoaded ) {
								if( ctListIdx >= createThumbnailList.length ) return;
								const thumbEntry = createThumbnailList[ctListIdx];
								const version = thumbEntry[0];
								const isDataVersion = thumbEntry[2];
								if( ctListIdx >= createThumbnailList.length-2 ) deferNextUntilImgLoaded = false;
								// console.log({w:'createNextThumbnail',ctListIdx,version,isDataVersion,deferNextUntilImgLoaded});
								MThumbnails.createOnTarget(
									thumbEntry[1],
									{
										media_id: m_media_id,
										width: 94,
										height: 72,
										version: version,
										thumb_loader_anim: true,
										on_load_cb: deferNextUntilImgLoaded ? function() {
											// console.log({w:'onload',ctListIdx,version,isDataVersion});
											createNextThumbnail(ctListIdx+1,isDataVersion);
										} : null,
									}
								);
								if( !deferNextUntilImgLoaded ) {
									createNextThumbnail(ctListIdx+1,isDataVersion);
								}
							};
							createNextThumbnail(0,false);
						}
					}

					md_latest_version_number = versions[0] ?? null;

					// default-select latest version entry
					mdd_select_version( md_latest_version_number, true );

					// add keyboard handlers for navigation list version list
					$(document).on('keydown.MVDetail', function( evt ) {
						// ignore keydown if other dialogs are opened
						if( $('#mv-compare-form,#mmbp-form,#mdli-form,#mxp-form,#mpub-form,#msslb-form,#ms-form,#mdl-form,#mp-form,#confirm-box,#error-box,#info-box,#mvl-values').is(':visible') ) return true;
						// ignore keydown on input elements
						if( $('#md-form').is(':visible') && $('#md-form :focus').filter(':input').length ) return true;
						// ignore alt+meta+(*) combinations (these may be used for tab navigation on OSX...)
						if( evt.altKey && evt.metaKey ) return true;
						let idx;
						switch( evt.which ) {
						case 37: // LEFT
							if( m_mids.length===1 && m_superior_media_id_list_cb ) {
								m_superior_media_id_list_cb( function() {
									switch_view(-1,true);
								} );
							} else {
								switch_view(-1,true);
							}
							return false;
						case 39: // RIGHT
							if( m_mids.length===1 && m_superior_media_id_list_cb ) {
								m_superior_media_id_list_cb( function() {
									switch_view(+1,true);
								} );
							} else {
								switch_view(+1,true);
							}
							return false;
						case 38: // UP
							if( versions.length ) {
								idx = parseInt( md_versions_list.children('.md-version-list-item.selected').attr('mj_idx'), 10 );
								mdd_select_version( versions[ idx===0 ? versions.length-1 : idx-1 ], false );
							}
							return false;
						case 40: // DOWN
							if( versions.length ) {
								idx = parseInt( md_versions_list.children('.md-version-list-item.selected').attr('mj_idx'), 10 );
								mdd_select_version( versions[ idx===versions.length-1 ? 0 : idx+1 ], false );
							}
							return false;
						case 27: // ESCAPE
							if( !evt.isDefaultPrevented() ) {
								closeDialog( $('#md-form') );
								evt.preventDefault();
								evt.stopPropagation();
							}
							return false;
						}
					} );

				} );

			};
		}

		function dtinfo_load_complete2() {
			if( MPlugins.isRegistered('ui-collabannot-thumb-view') ) {
				// toggle annotations tab - based on perms
				const showAnnotationsTab = !!m_dtinfo.r_annots_view;
				if( m_mode==='annotations' && !showAnnotationsTab ) {
					switch_mode('detail');
				}
				$('#md-form').closest('.ui-dialog').find('> .ui-dialog-titlebar > .ui-dialog-title')
					.mjDialogTabs('toggle','annotations',showAnnotationsTab);
			}
			dtinfo_load_complete();
			if( meta_loaded_cb ) meta_loaded_cb();
			else update_dlg_tabs_status();
		}

		abort_current_data_request();
		m_last_data_request = MDMedia.queryMediaDetailInfo( m_media_id, function _queryMediaDetailInfo_success( dtinfo ) {
			m_dtinfo = mj_deep_extend({},dtinfo);
			if( m_redt_count===null ) {
				return MDMedia.queryMediaEditableCount( m_mids, function _queryMediaEditableCount_success( editable_count ) {
					m_redt_count = editable_count;
					dtinfo_load_complete2();
				} );
			}
			return dtinfo_load_complete2();
		} );//, null, true );

	}


	function switch_canvas() {

		// reset canvas & toolbar
		m_preview_loader.removePreview();


		let md_canvas0, md_toolbar0;
		if( m_mode==='annotations' ) {
			md_canvas0 = md_annotations_canvas[0];
			md_toolbar0 = $('#md-annotations-toolbar')[0];
		} else {
			md_canvas0 = md_canvas[0];
			md_toolbar0 = $('#md-toolbar')[0];
		}

		if( m_media_id && m_dtinfo && m_dtinfo.meta && ( m_mode==='detail' || m_mode==='annotations' ) ) {
			let xopts = Object.assign(
				{
					enable_save_view_meta: true,
					enable_save_view_session: true,
					view_session_pfx: m_mode==='annotations'?'md_annotations_':'',
				},
				m_preview_xopts
			);
			xopts.close_on_escape_cb = function( evt ) {
				const closed = handle_escape_key(evt);
				return closed;
			};
			// m_preview_loader.onAfterCreatePreview( function( dtinfo, target_elem, xopts, toolbar_elem ) {
			// } );
			m_preview_loader.createPreviewWhenMediaPreviewAvailable(m_dtinfo,md_canvas0,xopts,md_toolbar0);
		}
	}

	function switch_data() {
		reset_media_upload_widget();
		if( m_mode==='detail' ) {
			MVMediaMetadata.setupMetadataViewData( $('#md-data'), m_media_id, m_dtinfo, false, true,
				function( container, rows, can_edit ) {
					close_edit_group(container,rows);
					container.find('>.title>.edit-group').hide();
					rows.children('th').css('cursor','').off('click');
					if( can_edit ) {
						switch_data_mgr(container,rows);
					}
				},
				{
					getContainerFilePreviewInfo: function( fe ) {

						// not yet
						return null;

						// const filename = fe.name||'';
						// const fileType = filename.endsWith('/') ? 'folder' : 'file';
						// if( fileType!=='file' ) {
						// 	return null;
						// }
						// const dotPos = filename.lastIndexOf('.');
						// if( dotPos===-1 ) {
						// 	return null;
						// }
						// const fileSuffix = filename.substring(dotPos+1).toLowerCase();
						// if( fileSuffix!=='html' ) {
						// 	return null;
						// }

						// window.mj.loadContainerFilePreview = function( loadArgs ) {
						// 	md_canvases.triggerHandler('mjscontainerfilepreviewsetup',[loadArgs.filename]);
						// };
						// const loadArgs = {
						// 	media_id: m_media_id,
						// 	filename,
						// };
						// return {
						// 	href: '#',
						// 	onclick: 'mj.loadContainerFilePreview('+JSON.stringify(loadArgs)+')',
						// };
					}
				}
			);
		}
	}

	function switch_data_mgr( container, rows ) {
		const edit_rows = rows.filter('[data-edit=1]');
		const ena_row_edit = function() {
			edit_rows.children('th').css('cursor','pointer')
				.off('click')
				.click( function() {
					const th = $(this);
					const tr = th.closest('tr');
					if( th.next('td').children('.data-holder').css('display')==='none' ) close_edit(tr);
					else edit_item(tr);
				} );
		};
		const dis_row_edit = function() {
			edit_rows.children('th').css('cursor','').off('click');
		};
		// add single-row "edit-item" functionality
		edit_rows.find('>td>.data-holder').addClass('data-holder-editable');

		$('<button type="button" class="iconic edit-item" title="'+mjt('md-edit-item')+'"></button>')
			.click( function() {
				edit_item($(this).closest('tr'));
			} )
			.appendTo( edit_rows.children('td') );
		ena_row_edit();
		// add "batch-process-item" functionality (available in single-row-edit-mode only)
		const edit_rows_not_cp = edit_rows.not('[data-meta_id=10]');
		if( m_mids.length>1 && m_redt_count>1 && !!m_superior_media_id_list_cb ) {
			$('<button type="button" class="iconic batch-process-item" title="'+mjt('md-batch-process-item')+'"></button>')
				.click( function() {
					batch_process_item($(this).closest('tr'));
				} )
				.appendTo( edit_rows_not_cp.children('td') );
		}
		// cleanup..
		const form = container.find('>.content>form');
		if( form.length ) {
			form.children('.edit-group-buttons').remove();
			form.replaceWith(form.contents());
		}
		// add group-edit functionality
		const group_edit_rows = edit_rows_not_cp;
		if( group_edit_rows.length ) {
			container.find('>.title>.edit-group').show()
				.off('click')
				.click( function() {
					const lnk = $(this);
					lnk.hide();
					dis_row_edit();
					lnk.closest('.title').not('.opened').click(); // = open container
					edit_group(container,group_edit_rows,function() {
						ena_row_edit();
						lnk.show();
					});
					return false;
				} );
		}
	}

	function close_edit( self_tr ) {
		self_tr.removeClass('mj-editing');
		const forms = self_tr.find('>td>form');
		forms.find('.hasDatepicker').datepicker('hide').datepicker('destroy');

		// destroy select2 widgets (TODO: use mjWidget instead of this mess)
		forms.find('.select2-hidden-accessible').each( function() {
			const s2w = $(this);
			if( s2w.data('select2') ) s2w.select2('destroy');
			s2w.removeData();
		} );

		forms.remove();
		self_tr.children('td').children('.data-holder,.edit-item,.batch-process-item').show();
		if( window.MValueLists ) MValueLists.Destroy();
	}


	function close_all_edits( md_data ) {
		// close all edit widgets (what a mess..)
		const edit_forms = md_data.find('.edit-item-form, .edit-group-form');
		if( edit_forms.length ) {
			edit_forms.each( function() {
				$(this).find('.edit-buttons button.cancel, .edit-group-buttons button.cancel').trigger('click');
			} );
		}
	}


	function refresh_special_fields() {
		const md_data = $('#md-data');

		MVMediaMetadata.saveMetadataViewDataScrollPos( md_data );		// save scroll pos here -> it will be restored in MDMediaMeta observers bindMetaChanged

		/* refreshes the following fields:
		 - modified-datetime, modified-by,
		 - version-number, version-comment, version-type,
		 - content-type, media-class,
		 - filename, filesize, file-extension
		 - advised-of-expiry-datetime, expired-datetime
		*/
		MVMediaMetadata.refreshSelectedMetadataViewRows( md_data, m_media_id, [-4,-3,13,14,15,-2,-1,1,5,6,49,50,51,52,53], m_dtinfo );
	}

	function trigger_full_meta_changed() {
		/* triggers meta change & category change observers
		 - on all meta_ids in current info
		 - on all tree_ids in current info
		*/
		let data = { meta:{}, categories:{} };
		data.meta[m_media_id] = m_dtinfo.meta;
		data.categories[m_media_id] = m_dtinfo.categories;
		MDMedia.triggerFullMetaChanged( [m_media_id], data, true, true );
		update_dlg_tabs_status();
	}





	function edit_item( self_tr ) {
		const self_td = self_tr.children('td');

		let html = '';
		html += '<form class="edit-item-form" method="post" accept-charset="UTF-8">';
		html += '<div class="edit-widgets"></div>';
		html += '<div class="edit-buttons">';
		html += '<button type="submit" class="iconic submit" title="'+mjt('save')+'"></button>';
		html += '<button type="button" class="iconic cancel" title="'+mjt('cancel')+'"></button>';
		if( m_mids.length>1 && m_redt_count>1 && self_tr.hasClass('md-m') && !!m_superior_media_id_list_cb ) {
			html += '<button type="button" class="iconic batch-process-item" title="'+mjt('md-batch-process-item')+'"></button>';
		}
		html += '</div>';
		html += '</form>';

		self_tr.addClass('mj-editing');
		const form = self_td
			.children('.data-holder,.edit-item,.batch-process-item')
			.hide()
			.end()
			.prepend(html)
			.children('form.edit-item-form');
		const on_cancel = function() {
			close_edit(self_tr);
			return false;
		};

		const btns_div = form.children('.edit-buttons');
		const wdgs_div = form.children('.edit-widgets');
		setupRowEditing(self_tr,btns_div,wdgs_div,true,on_cancel);

		btns_div
			.children('.cancel').on('click',on_cancel).end()
			.children('.batch-process-item').click( function() {

				let editing_meta_id = null;
				let editing_meta_data = null;
				if( self_tr.hasClass('md-m') ) {
					editing_meta_id = self_tr.data('meta_id');
					editing_meta_data = getEditRowDataOfMeta(editing_meta_id,wdgs_div);
					// console.log({editing_meta_id,editing_meta_data});
				}

				close_edit(self_tr);

				batch_process_item(self_tr, function( initial_meta ) {
					if( editing_meta_id!==null ) {
						initial_meta[editing_meta_id] = editing_meta_data;
					}
					return initial_meta;
				} );
			} );

		form.submit( function(e) {
			e.preventDefault();
			const wdgs_div = $(this).children('.edit-widgets');

			if( self_tr.hasClass('md-t') ) {
				const tree_id = self_tr.data('tree_id');
				const edit_data = getEditRowDataOfTree(tree_id,wdgs_div);
				MDMedia.saveCategoryAssignment( [m_media_id], tree_id, edit_data, function( updated_categories, updated_meta ) {
					m_dtinfo.categories = mj_deep_extend( {}, updated_categories[m_media_id] || {} );
					if( updated_meta ) m_dtinfo.meta = mj_deep_extend( {}, updated_meta[m_media_id] || {'-1':[0]} );
					const cat_ids=m_dtinfo.categories[tree_id] || [];
					self_tr.removeClass('md-hide').addClass('md-avl')
						.find('.data-holder').html(
							MVMediaMetadata.getCategoryListNodesSnippet(tree_id,cat_ids)
						);
					showInfoToast(mjt('md-category-saved'));
					close_edit(self_tr);
					refresh_special_fields();
				}, function( error ) {
					// TODO: localize error message:
					showWarningToast( 'Fehler, Kategorie konnte nicht zugewiesen werden. ' + error );
				}, false, true );
			} else if( self_tr.hasClass('md-m') ) {
				const meta_id = self_tr.data('meta_id');
				const edit_data = getEditRowDataOfMeta(meta_id,wdgs_div);
				MDMedia.saveMetaValue( [m_media_id], meta_id, edit_data, function( updated_meta ) {
					m_dtinfo.meta = mj_deep_extend( {}, updated_meta[m_media_id] || {'-1':[0]} );
					const metaDisplayHtml = MVMediaMetadata.getInteractiveDisplayData(m_dtinfo.meta[meta_id]||[],meta_id);
					self_tr
						.removeClass('md-hide').addClass('md-avl')
						.find('.data-holder').html(metaDisplayHtml);
					showInfoToast(mjt('md-info-saved'));
					close_edit(self_tr);
					refresh_special_fields();
				}, function( error ) {
					// TODO: localize error message:
					showWarningToast( 'Fehler, Daten konnten nicht gespeichert werden. ' + error );
				} );
			}
			return false;
		} );

		// "add to all open files" form
		if( m_mids.length>1 && m_redt_count>1 && self_tr.hasClass('md-m') && !!m_superior_media_id_list_cb ) {
			const meta_id = self_tr.data('meta_id');
			if( meta_id!=10 ) {	// 10=MSD_CUSTOM_PREVIEW_WIDTH
				const md = MDMeta.getDefinition(meta_id);
				if( md.list ) {
					switch( md.type ) {
					case 0: // MT_STRING
					case 1: // MT_TEXT
					case 2: // MT_INT
					case 3: // MT_REAL
					case 8: // MT_REF_MEDIA
						MVMediaMetadataEditWidgets.setupAdd2AllOpenFilesWidget( md, form, function( data2AddArr ) {
							let txt = '';
							if( m_redt_count===m_mids.length ) txt = mjt('md-confirm-save-add2all').replace('%d','<span class="big">'+MDLocale.fmt_number(m_mids.length)+'</span>');
							else txt = mjt('md-confirm-save-add2all-2').replace('%1','<span class="big">'+MDLocale.fmt_number(m_redt_count)+'</span>').replace('%2','<span class="big">'+MDLocale.fmt_number(m_mids.length)+'</span>');

							confirm_box( mjt('md-confirm-save-add2all-title'), txt, function() {
								MDMedia.addMetaValue( m_mids, meta_id, data2AddArr, function( updated_meta ) {
									m_dtinfo.meta = mj_deep_extend( {}, updated_meta[m_media_id] || {'-1':[0]} );
									const metaDisplayHtml = MVMediaMetadata.getInteractiveDisplayData(m_dtinfo.meta[meta_id]||[],meta_id);
									self_tr
										.removeClass('md-hide').addClass('md-avl')
										.find('.data-holder').html(metaDisplayHtml);
									showInfoToast( m_redt_count===m_mids.length ? mjt('md-info-saved-add2all') : mjt('md-info-saved-add2all-2').replace('%d',m_redt_count.toString()) );
									close_edit(self_tr);
									refresh_special_fields();
								}, function( error ) {
									// TODO: localize error message:
									showWarningToast( 'Fehler, Daten konnten nicht gespeichert werden. ' + error );
								} );
							} );

						} );
						break;
					case 4: // MT_BINARY
					case 5: // MT_DATE - date selector
					case 6: // MT_TIME - time selector
					case 7: // MT_DATETIME - date+time selector
						// not available
						break;
					case 9: // MT_OBJECT
						// not implemented yet
						break;
					}
				}
			}
		}
	}


	//TODO: refactor save_all() function ...
	function save_all( meta_id, tree_id ) {
		// save for all media_ids except the current one
		let save_ids=[];
		const ml = m_mids.length;
		for( var i=0; i<ml; ++i ) {
			if( m_mids[i]!=m_media_id ) save_ids.push(m_mids[i]);
		}
		if( save_ids.length===0 ) return;
		if( tree_id ) {
			const cat_ids = m_dtinfo.categories[tree_id] || [];
			MDMedia.saveCategoryAssignment( save_ids, tree_id, cat_ids, function( updated_categories ) {
				// success
				showInfoToast( m_redt_count===m_mids.length ? mjt('md-category-saved-all') : mjt('md-category-saved-all-2').replace('%d',m_redt_count.toString()) );
			}, function( error ) {
				// TODO: localize error message:
				showWarningToast( 'Fehler, Kategorie konnte nicht zugewiesen werden. ' + error );
			} );
		} else if( meta_id ) {
			const value = m_dtinfo.meta[meta_id] || [''];
			MDMedia.saveMetaValue( save_ids, meta_id, value, function( updated_meta ) {
				// success
				showInfoToast( m_redt_count===m_mids.length ? mjt('md-info-saved-all') : mjt('md-info-saved-all-2').replace('%d',m_redt_count.toString()) );
			}, function( error ) {
				// TODO: localize error message:
				showWarningToast( 'Fehler, Daten konnten nicht gespeichert werden. ' + error );
			} );
		}
	}

	function batch_process_item( self_tr, process_initial_meta_cb ) {
		if( self_tr.hasClass('md-t') ) {
			// category assignments: the only functionality available is "for all" ...
			const tree_id = self_tr.data('tree_id');
			let txt = '';
			if(m_redt_count===m_mids.length) txt = mjt('md-confirm-save-categories-for-all').replace('%d','<span class="big">'+MDLocale.fmt_number(m_mids.length)+'</span>');
			else txt = mjt('md-confirm-save-categories-for-all-2').replace('%1','<span class="big">'+MDLocale.fmt_number(m_redt_count)+'</span>').replace('%2','<span class="big">'+MDLocale.fmt_number(m_mids.length)+'</span>');
			confirm_box(mjt('md-confirm-save-categories-for-all-title'),txt,function() {
				save_all(null,tree_id);
			});
		} else if( self_tr.hasClass('md-m') ) {
			// metadata: available functionality may be "for all" and "auto-numbering" ...
			const meta_id = self_tr.data('meta_id');

			const batch_processable_rows = self_tr.closest('.md-data').find('button.batch-process-item').closest('tr').filter('.md-m');

			let cur_idx_into_batch_processable_meta_ids = 0;
			let batch_processable_meta_ids = [];
			batch_processable_rows.each( function(idx,row) {
				const c_meta_id = $.data(row,'meta_id');
				batch_processable_meta_ids.push(c_meta_id);
				if( c_meta_id==meta_id ) cur_idx_into_batch_processable_meta_ids = idx;
			});

			let initial_meta = m_dtinfo.meta || {};
			if( process_initial_meta_cb ) {
				initial_meta = process_initial_meta_cb(initial_meta);
			}

			MVMediaMetaBatchProcessing.open(
				batch_processable_meta_ids,
				cur_idx_into_batch_processable_meta_ids,
				m_media_id,
				m_mids,
				function _select_meta_cb( meta_id ) {
					const selected_tr = batch_processable_rows.filter('.md-m-'+meta_id);
					if( selected_tr.hasClass('mj-editing') ) {
						close_edit(selected_tr);
					}
				},
				function _done_cb() {
					switch_mode(m_mode);
				},
				initial_meta,
				MVMediaMetadataEditWidgets.setupMetadataEditWidget,
				MVMediaMetadataEditWidgets.getMetadataEditWidgetData
			);
		}
	}


	function edit_group( container, edit_rows, on_close ) {
		// remove any existing edit-widgets, hide buttons & data..
		edit_rows
			.children('td')
			.children('form').remove().end()
			.children('.data-holder,.edit-item,.batch-process-item').hide().end()
			.prepend('<div class="edit-widgets"></div>');
		if( window.MValueLists ) MValueLists.Destroy();
		// add form
		const form = container.children('.content').wrapInner('<form class="edit-group-form" method="post" accept-charset="UTF-8" />').children('form');
		const on_cancel = function() {
			close_edit_group(container,edit_rows,on_close);
			return false;
		};
		// add edit-widgets
		let is_first = true;
		edit_rows.each( function() {
			const tr = $(this);
			const wdgs_div = tr.find('>td>.edit-widgets');
			setupRowEditing(tr,null,wdgs_div,is_first,on_cancel);
			is_first = false;
		} );
		// setup form
		let html_tmp = '';
		html_tmp += '<div class="edit-group-buttons">';
		html_tmp += '<button type="submit" class="button-primary">'+mjt('save')+'</button>';
		html_tmp += '</div>';
		const edit_group_buttons = $(html_tmp).appendTo(form);
		$('<button type="button" class="cancel button-secondary">'+mjt('cancel')+'</button>')
			.click(on_cancel)
			.appendTo(edit_group_buttons);

		form.submit( function() {
			let edit_data = {};
			const mdt_rows=edit_rows.filter('.md-t');
			if( mdt_rows.length ) {
				edit_data.categories = {};
				mdt_rows.each( function() {
					const tr = $(this);
					const wdgs_div = tr.find('>td>.edit-widgets');
					const tree_id = tr.data('tree_id');
					edit_data.categories[tree_id] = getEditRowDataOfTree(tree_id,wdgs_div);
				} );
			}
			const mdm_rows=edit_rows.filter('.md-m');
			if( mdm_rows.length ) {
				edit_data.meta = {};
				mdm_rows.each( function() {
					const tr = $(this);
					const wdgs_div = tr.find('>td>.edit-widgets');
					const meta_id = tr.data('meta_id');
					edit_data.meta[meta_id] = getEditRowDataOfMeta(meta_id,wdgs_div);
				} );
			}
			MDMedia.saveMetaData( [m_media_id], edit_data, function( updated_data ) {
				if( mdt_rows.length ) {
					m_dtinfo.categories = mj_deep_extend( {}, updated_data.categories[m_media_id] || {} );
					mdt_rows.removeClass('md-hide').addClass('md-avl').each( function() {
						const tr = $(this);
						const tree_id = tr.data('tree_id');
						const cat_ids = m_dtinfo.categories[tree_id] || [];
						tr.find('>td>.data-holder').html(
							MVMediaMetadata.getCategoryListNodesSnippet(tree_id,cat_ids)
						);
					} );
				}
				if( mdm_rows.length ) {
					m_dtinfo.meta = mj_deep_extend( {}, updated_data.meta[m_media_id] || {'-1':[0]} );
					mdm_rows.removeClass('md-hide').addClass('md-avl').each( function() {
						const tr = $(this);
						const meta_id = tr.data('meta_id');
						const metaDisplayHtml = MVMediaMetadata.getInteractiveDisplayData(m_dtinfo.meta[meta_id]||[],meta_id);
						tr.find('>td>.data-holder').html(metaDisplayHtml);
					} );
				}
				showInfoToast(mjt('md-info-saved'));
				close_edit_group(container,edit_rows,on_close);
				refresh_special_fields();
			}, function( error ) {
				// TODO: localize error message:
				showWarningToast( 'Fehler, Daten konnten nicht gespeichert werden. ' + error );
			} );
			return false;
		} );
	}

	function close_edit_group( container, edit_rows, on_close ) {
		const form = container.find('>.content>form');
		if( form.length ) {
			form.children('.edit-group-buttons').remove();
			form.replaceWith(form.contents());
		}

		const edit_elems = edit_rows.find('>td>.edit-widgets,>td>.edit-xinfo');
		edit_elems.find('.hasDatepicker').datepicker('hide').datepicker('destroy');
		edit_elems.remove();
		edit_rows.find('>td>.data-holder,>td>.edit-item,>td>.batch-process-item').show();
		if( window.MValueLists ) MValueLists.Destroy();
		if( on_close ) on_close();
	}


	// TODO: use appropriate mjWidget !
	function _buildTreeNodesSelect( tree_id, selected_id, enable_remove_button ) {
		const tree_nodes = mj.trees[tree_id].nodes || {};
		const tno = mj.trees[tree_id].nodes_order || [];
		const node_known = selected_id==0 || (selected_id in tree_nodes);
		let html = '';
		let tsopts = '';
		let node_enabled;
		const tnolen = tno.length;
		for( var cidx=0; cidx<tnolen; ++cidx ) {
			let cat_id = tno[cidx];
			const node = tree_nodes[cat_id];
			cat_id = parseInt(cat_id,10);
			node_enabled = tree_id!=1 || arr_inArray(cat_id,mj.upload_categories)!=-1;
			const parent = (node.parent!=0)?'data-parent="'+node.parent+'"':'';
			let css = '';
			if(node.depth == -1) css = 'style="font-style:italic"';
			html += '<option '+parent+' '+css+' value="'+cat_id+'"'+(node_enabled?'':' disabled="disabled"')+(selected_id==cat_id?' selected="selected"':'')+'>'+htmlspecialchars(node.name)+'</option>';
		}
		html += '<option style="font-style:italic" value="0"'+(selected_id==0?' selected="selected"':'')+'>'+mjt('md-no-category-assigned')+'</option>';
		if( !node_known ) {
			node_enabled = tree_id!=1 || arr_inArray(selected_id,mj.upload_categories)!=-1;
			tsopts += '<option style="font-style:italic" value="'+selected_id+'"'+(node_enabled?'':' disabled="disabled"')+' selected="selected" title="'+mjt('md-unknown-category-title').replace(/%1/,selected_id)+'">'+'(...) '+mjt('md-unknown-category')+'</option>';
		}
		let r = [];
		if( enable_remove_button ) r.push( $('<div class="wrap-remove-category"><span class="remove-category"></span></div>') );

		const wrapped_select_elem = $('<div class="wrap-category"><select name="cat_id" size="1">'+html+tsopts+'</select></div>');
		// make select2 tree widget
		wrapped_select_elem.find('select[name=cat_id]').select2({
			resultsAdapter: $.fn.select2.amd.require('mjSelect2TreeResultsAdapter'),
			dataAdapter: $.fn.select2.amd.require('mjSelect2TreeDataAdapter'),
			selectionAdapter: $.fn.select2.amd.require('mjSelect2TreeSelectionAdapter'),
			dropdownAutoWidth: false,
			showEntityIds: true,
		});
		// remove css width (select2 measured <select>s width and sets that as css width in pixels, which is a stupid idea for most cases)
		wrapped_select_elem.find('.select2-container').css({width:''});

		r.push( wrapped_select_elem );
		return r;
	}





	//--START--REFACTORING--REQUIRED--//
	function setupRowEditing( self_tr, btns_div, wdgs_div, do_focus, on_cancel ) {
		let focus_node = null;
		if( self_tr.hasClass('md-t') ) {
			const tree_id = self_tr.data('tree_id');
			wdgs_div.addClass(MVMediaMetadata.getTreeDataHolderClassList(tree_id));

			let selected_ids = [];
			self_tr.children('td').find('.cat-id').each(function(idx,elm) {
				selected_ids.push( parseInt($(this).text(),10) );
			});
			if( selected_ids.length===0 ) selected_ids.push(0); // nothing assigned => add a single select box to select first assignment
			for( var sidx=0; sidx<selected_ids.length; ++sidx ) {
				wdgs_div.append( _buildTreeNodesSelect(tree_id,selected_ids[sidx],sidx>0) );
			}
			focus_node = wdgs_div.find('select[name=cat_id]').first();
			if( mj.trees[tree_id].multifiling ) {
				wdgs_div.append('<button type="button" class="iconic add-data" title="'+mjt('md-add-category')+'"></button>');
				wdgs_div.children('.add-data').click(function() {
					wdgs_div.children('.add-data').before( _buildTreeNodesSelect(tree_id,0,true) );
				});
			}
			// remove-category functionality...
			wdgs_div.off('click','.remove-category').on('click','.remove-category',function() {
				const wrc = $(this).parent();
				wrc.next('.wrap-category').add(wrc).remove();
			});
		} else if( self_tr.hasClass('md-m') ) {
			const meta_id = self_tr.data('meta_id');
			const md = MDMeta.getDefinition(meta_id);
			wdgs_div.addClass(MVMediaMetadata.getMetaDataHolderClassList(meta_id,!!md.list));

			const varray = m_dtinfo.meta[meta_id] && m_dtinfo.meta[meta_id].length ? m_dtinfo.meta[meta_id] : [''];

			focus_node = MVMediaMetadataEditWidgets.setupMetadataEditWidget(md,btns_div,wdgs_div,focus_node,varray);

			MPlugins.iterateByTypeAndMetaId( 'MediaMetaEditView', meta_id, function( name, plugin ) {
				plugin.setupEditView(
					m_media_id,
					meta_id,
					btns_div,
					wdgs_div,
					varray,
					m_dtinfo,
					function() {
						close_edit(self_tr);
						refresh_special_fields();
					},
					function() {
						switch_canvas();
					}
				);
			} );
		}

		// keyhandler for ESC (will close edit mode and avoid closing whole dialog)
		wdgs_div.on('keydown.MVDetail','input[type=text],textarea,select,button', function(evt) {
			if( evt.which && evt.which===27 && !evt.isDefaultPrevented() ) {
				if( $(this).areacomplete('isListVisible') ) {
					// ignore -> let "areacomplete" code handle ESC keydown
				} else {
					if( $('#mvl-values').is(':visible') ) return true;
					on_cancel();
				}
				evt.preventDefault();
				evt.stopPropagation();
			}
		} );

		if( do_focus && focus_node ) {
			if( focus_node.is('input[type=text]') ) focus_node.select();
			else focus_node.focus();
		}
	}


	function getEditRowDataOfMeta( meta_id, wdgs_div ) {
		const md = MDMeta.getDefinition(meta_id);
		if( meta_id==10 ) {
			// custom preview
			return [];
		}
		return MVMediaMetadataEditWidgets.getMetadataEditWidgetData(md,wdgs_div);
	}

	function getEditRowDataOfTree( tree_id, wdgs_div ) {
		let rv = [];
		wdgs_div.find('[name=cat_id]').each( function() {
			const v = $(this).val();
			if( v!=='' && v!=='0' ) rv.push(v);
		} );
		return rv;
	}



	//--END--REFACTORING--REQUIRED--//







	function get_toolbar_selector() {
		if( m_mode==='detail' ) return '#md-toolbar';
		else if( m_mode==='annotations' ) return '#md-annotations-toolbar';
		return '#md-unknown-toolbar';
	}


	function reset_media_upload_widget() {
		$('#mdu_upload_swf').mjUploadWidget('destroy');
		$('#mdu_upload_box').remove();
		if( m_dtinfo && m_dtinfo.r_edit ) {
			$(get_toolbar_selector()+' .mdb-upload-i').show();
		}
	}

	function show_media_upload_widget() {
		tb_popup_menu_close();
		const media_id = m_media_id;
		const postdata = 'media_id='+encodeURIComponent(media_id)+'&prioritize=1';
		postToBackend('json/media/meta-mprevprogress', postdata, function(j) {
			if( j && ( j.hasOwnProperty('p') || j.retry ) ) {
				// post import or delayed post import in progress .. do not allow to replace file at the moment ...
				showInfoToast(mjt('mdb-upload-not-possible-another-import-in-progress'));
			} else {
				const is_safari_workaround = ( Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 ) || ( navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') );
				const $upload_menu_btn = $(get_toolbar_selector()+' .mdb-upload-i');
				if( is_safari_workaround ) {
					$upload_menu_btn.hide();
				}

				$upload_menu_btn.after('<span id="mdu_upload_box"><span id="mdu_upload_swf"></span><span id="mdu_upload_queue" style="display:none"></span></span>');

				$('#mdu_upload_swf').mjUploadWidget( {
					type: 'single',
					auto_start: !is_safari_workaround,
					minify: !is_safari_workaround,
					upload_url: 'json/media/manage-replace',
					post_params: { media_id:media_id },
					file_types: '*.*',
					file_types_description: mjt('all-file-types'),
					button_text: mjt('mdb-upload-button'),
					start: function( file ) {
						$('#mdu_upload_queue').empty().show();
						startProgress(true);
					},
					success: function( file, j ) {
						showInfoToast(mjt('mdb-upload-success'));
						MDMedia.invalidateMediaCaches( [media_id] );
						if( j.meta && j.meta[media_id] ) m_dtinfo.meta = mj_deep_extend( {}, j.meta[media_id] || {'-1':[0]} );
						if( j.categories && j.categories[media_id] ) m_dtinfo.categories = mj_deep_extend( {}, j.categories[media_id] || {} );
						// notify observers on meta & category changes
						trigger_full_meta_changed();

						// remove current preview... view will be updated as soon new one is ready...
						m_preview_loader.removePreview();

						// wait until the file is ready for previewing ...
						// eslint-disable-next-line no-unused-vars
						let timeout_id = 0;
						const _go = function() {
							const postdata = 'media_id='+encodeURIComponent(media_id)+'&meta_ids='+encodeURIComponent(mj.required_thumbnail_meta_ids.join(','));
							postToBackend2( 'json/widgets/meta-media_thumb_info', postdata, function(xj) {
								if( xj && ( xj.available || xj.error ) ) {
									if( media_id==m_media_id ) {
										// update detail view ...
										switch_view( m_midx, false, function() {
											// done ...
											md_canvases.triggerHandler('mjsshow');
											// re-create thumbnails in all views
											$(document).triggerHandler('mjsrecreatethumbnails',[media_id,m_dtinfo.meta]);
										} );
									} else {
										// just re-create thumbnails in views
										$(document).triggerHandler('mjsrecreatethumbnails',[media_id,xj.meta]);
									}
								} else {
									// retry
									timeout_id = setTimeout( _go, 1500 );
								}
							}, function() {
								// timeout handler - try again later
								timeout_id = setTimeout( _go, 2250 );
							} );
						};
						_go();
					},
					fail: function( file ) {
						setTimeout( function() {
							// reload widget (the upload may have finished on server, even if aborted on client...)
							// ???
						}, 200 );
					},
					complete: function( file ) {
						stopProgress();
						// reset upload widget
						reset_media_upload_widget();
					},
					cancel: function( file ) {
						stopProgress();
						// reset upload widget
						reset_media_upload_widget();
					}
				} )
					.find('.muw-button')
					.focus();
			}
		} );
	}

	function show_media_link( mids, midx ) {
		let url;
		if( mids.length===1 ) {
			url = mj.uwn + '/media/#details='+encodeURIComponent(mids[0]);
		} else {
			const details = { media_ids:mids, index:midx };
			url = mj.uwn + '/media/#details='+encodeURIComponent(JSON.stringify(details));
		}
		copyToClipboard(url);
		showInfoToastWithLink(mjt('md-link-info','!'), url, {buttonCopy2Clipboard: true});
	}


	function tb_popup_menu_close() {
		// return $('#md-form').off('.MVDetailPopupMenu'); // SKIP
		// const cur_canvas = get_cur_canvas();
		// if( cur_canvas ) {
		// 	const $m = $('#mdb-popup-menu-i');
		// 	if( $m.length ) {
		// 		cur_canvas.triggerHandler('mjsmenuclose',[$m]);
		// 	}
		// }
		$('#mdb-popup-menu').remove();
		const $md_form = $('#md-form').off('.MVDetailPopupMenu');
		return $md_form;
	}


	function tb_popup_menu_cancel_hide() {
		if( m_tb_hover_off_timeout_id!==null ) {
			clearTimeout(m_tb_hover_off_timeout_id);
			m_tb_hover_off_timeout_id = null;
		}
	}

	function tb_popup_menu_hide( speed ) {
		tb_popup_menu_cancel_hide();
		if( speed==0 ) {
			tb_popup_menu_close();
		} else {
			const do_hide = function() {
				$('#mdb-popup-menu').fadeOut( 200, tb_popup_menu_close );
				m_tb_hover_off_timeout_id = null;
			};
			// speed *= 300; // <-- TESTING
			m_tb_hover_off_timeout_id = setTimeout( do_hide, speed );
		}
	}

	function find_in_m_mids( search_media_id, found_cb ) {
		for( var x=0; x<m_mids.length; ++x ) {
			if( m_mids[x]==search_media_id ) {
				found_cb( x );
				break;
			}
		}
	}


	function tb_click( e, act, single ) {
		tb_popup_menu_hide(0);
		e.preventDefault();
		const mids = single ? [m_media_id] : m_mids;
		const stitle = single ? (m_dtinfo.meta[101]?m_dtinfo.meta[101][0]:'') : '';
		reset_media_upload_widget();
		switch( act ) {
		case 'link':		show_media_link(mids,single?0:m_midx);				break;
		case 'download':	if(m_dtinfo.r_download) MVDownload.open(mids);		break;
		case 'send':		MVSend.openMediaIDs(mids);							break;
		case 'link-extern': MVSend.openMediaIDs(mids, undefined, 'link');		break;
		case 'publish':		MVPublish.open(mids);								break;
		case 'export':		MVExport.open(mids);								break;
		case 'print':		MVPrint.open(mids,stitle);							break;
		case 'upload':		show_media_upload_widget();							break;
		case 'delete':
			delete_media(
				mids,
				function _deleted_cb( deleted_mids ) {
					// remove deleted entries from m_mids ..
					for( var i=0; i<deleted_mids.length; ++i ) {
						const dmid = deleted_mids[i];
						// remove that entry from m_mids
						find_in_m_mids( dmid, function( x ) {
							m_tmp_mids_b4del_order[dmid] = x>0 ? m_mids[x-1] : 0;
							m_mids.splice(x,1);
							m_redt_count = null; // must be queried again
						} );
					}
					if( m_mids.length===0 ) hide();
					else switch_view(m_midx);
				},
				function _restored_cb( restored_media_ids ) {
					if( m_mids.length === 0 ) {
						// detail view is already closed ...
						return;
					}
					for( var i=0; i<restored_media_ids.length; ++i ) {
						const rmid = restored_media_ids[i];
						const insert_after_mid = m_tmp_mids_b4del_order[rmid] ?? 0;
						if( insert_after_mid===0 ) {
							// insert in front
							m_mids.splice(0,0,rmid);
						} else {
							find_in_m_mids( insert_after_mid, function( x ) {
								m_mids.splice(x+1,0,rmid);
							} );
						}
					}
					m_redt_count = null; // must be queried again
					switch_view(m_midx);
				}
			);
			break;
		case 'lightbox':
		case 'lb-in':
			Lightbox.insert(mids);
			break;
		case 'lb-out':
			Lightbox.remove(mids);
			break;
		case 'lb-other':
			Lightbox.insertIntoOther(mids);
			break;
		case 'advanced':
			if( mj.role_user || mj.role_manager || mj.role_administrator ) {
				MVDownloadInfo.open(mids);
			} else {
				MVCompare.selectItem(m_media_id,null,true);
			}
			break;
		case 'advanced-download-info':
			MVDownloadInfo.open(mids);
			break;
		case 'advanced-compare':
			if( single ) MVCompare.selectItem(m_media_id,null,true);
			else MVCompare.startCompare(mids[m_midx],null,mids[(m_midx+1)%mids.length],null);
			break;
		case 'advanced-bulk-perms':
			MVBulkPermissions.open(mids);
			break;
		case 'advanced-post-import':
			maintenance_post_import_media(mids);
			break;
		case 'advanced-update':
			maintenance_update_media(mids);
			break;
		case 'advanced-re-import':
			maintenance_re_import_media(mids);
			break;
		}
	}

	function tb_hover( elem, act, hover_evt ) {
		tb_popup_menu_cancel_hide();
		const $md_form = tb_popup_menu_close();
		const m = $('<div id="mdb-popup-menu-i" class="popup-menu-i" data-act="'+act+'"></div>');
		const c1 = function(e) {
			tb_click(e,act,true);
		};
		const c2 = function(e) {
			tb_click(e,act,false);
		};
		switch( act ) {
		case 'link':
			$( '<a href="#"><b>'+mjt('mdbt-link-s')+'</b></a>' ).click(c1).appendTo(m);
			$( '<a href="#"><b>'+mjt('mdbt-link-se')+'</b></a>' ).click(function(e) {
				tb_click(e,'link-extern',true);
			}).appendTo(m);
			if( m_mids.length>1 ) {
				$( '<a href="#">'+mjt('mdbt-link-m')+'</a>' ).click(c2).appendTo(m);
				$( '<a href="#">'+mjt('mdbt-link-me')+'</a>' ).click(function(e) {
					tb_click(e,'link-extern',false);
				}).appendTo(m);
			}
			break;
		case 'download':
			if( m_dtinfo.r_download ) {
				$( '<a href="#"><b>'+mjt('mdbt-download-s')+'</b></a>' ).click(c1).appendTo(m);
				if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-download-m')+'</a>' ).click(c2).appendTo(m);
			}
			break;
		case 'send':
			$( '<a href="#"><b>'+mjt('mdbt-send-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-send-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'publish':
			$( '<a href="#"><b>'+mjt('mdbt-publish-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-publish-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'export':
			$( '<a href="#"><b>'+mjt('mdbt-export-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-export-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'print':
			$( '<a href="#"><b>'+mjt('mdbt-print-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-print-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'upload':
			$( '<a href="#"><b>'+mjt('mdbt-upload-s')+'</b></a>' ).click(c1).appendTo(m);
			break;
		case 'delete':
			$( '<a href="#"><b>'+mjt('mdbt-delete-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-delete-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'lb-in':
			$( '<a href="#"><b>'+mjt('mdbt-lb-in-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-lb-in-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'lb-out':
			$( '<a href="#"><b>'+mjt('mdbt-lb-out-s')+'</b></a>' ).click(c1).appendTo(m);
			if( m_mids.length>1 ) $( '<a href="#">'+mjt('mdbt-lb-out-m')+'</a>' ).click(c2).appendTo(m);
			break;
		case 'advanced':
			if( mj.role_user || mj.role_manager || mj.role_administrator || mj.role_maintenance ) {
				if( mj.role_administrator || mj.role_maintenance ) {

					$( '<a href="#">'+mjt('mdbt-bulk-perms-m')+'</a>' ).click(function(e) {
						tb_click(e,'advanced-bulk-perms',false);
					}).appendTo(m);

					$( '<a href="#"><b>'+mjt('mdbt-post-import-s')+'</b></a>' ).click(function(e) {
						tb_click(e,'advanced-post-import',true);
					}).appendTo(m);
					if( m_mids.length>1 ) {
						$( '<a href="#">'+mjt('mdbt-post-import-m')+'</a>' ).click(function(e) {
							tb_click(e,'advanced-post-import',false);
						}).appendTo(m);
					}

					$( '<a href="#"><b>'+mjt('mdbt-update-s')+'</b></a>' ).click(function(e) {
						tb_click(e,'advanced-update',true);
					}).appendTo(m);
					if( m_mids.length>1 ) {
						$( '<a href="#">'+mjt('mdbt-update-m')+'</a>' ).click(function(e) {
							tb_click(e,'advanced-update',false);
						}).appendTo(m);
					}

					$( '<a href="#"><b>'+mjt('mdbt-re-import-s')+'</b></a>' ).click(function(e) {
						tb_click(e,'advanced-re-import',true);
					}).appendTo(m);
					if( m_mids.length>1 ) {
						$( '<a href="#">'+mjt('mdbt-re-import-m')+'</a>' ).click(function(e) {
							tb_click(e,'advanced-re-import',false);
						}).appendTo(m);
					}

					$( '<span></span>' ).appendTo(m);
				}
				$( '<a href="#"><b>'+mjt('mdbt-download-info-s')+'</b></a>' ).click(function(e) {
					tb_click(e,'advanced-download-info',true);
				}).appendTo(m);
				if( m_mids.length>1 ) {
					$( '<a href="#">'+mjt('mdbt-download-info-m')+'</a>' ).click(function(e) {
						tb_click(e,'advanced-download-info',false);
					}).appendTo(m);
				}
			}
			// compare...
			$( '<a href="#"><b>'+mjt('mdbt-compare-s')+'</b></a>' ).click(function(e) {
				tb_click(e,'advanced-compare',true);
			}).appendTo(m);
			if( m_mids.length>1 ) {
				$( '<a href="#">'+mjt('mdbt-compare-m')+'</a>' ).click(function(e) {
					tb_click(e,'advanced-compare',false);
				}).appendTo(m);
			}
			break;
		}
		$('<div id="mdb-popup-menu" class="popup-menu" data-act="'+act+'"></div>')
			.append(m)
			.appendTo($md_form);

		let handlers_called_update_menu_count = 0;
		function update_menu( update_menu_act, dbginfo ) {
			handlers_called_update_menu_count ++;
			const pm = $('#mdb-popup-menu',$md_form);
			if( !pm.length ) {
				return; // this callback was triggered too late ...
			}
			const data_act = pm.data('act');
			if( update_menu_act!==data_act ) {
				return; // this callback was triggered for another action (probably too late) ...
			}
			const m = $('#mdb-popup-menu-i',pm);
			const a = m.children('a');
			const ah = a.length>0 ? a.length * ( 0 + a.first().outerHeight() ) : 0;
			const span = m.children('span');
			const spanh = span.length>0 ? span.length * ( 0 + span.first().outerHeight() ) : 0;
			const h = ah + spanh + 6;
			const p2 = $(elem).offset();
			const p1 = $md_form.offset();
			const x = (p2.left-p1.left) - (m.width()||0)/2 + 8;
			const y = (p2.top-p1.top) - h - 3;
			// console.log({w:'update_menu',dbginfo,handlers_called_update_menu_count,elemClassName:elem.className,act,update_menu_act});
			pm.css( {top:y+'px',left:x+'px',height:''+h+'px'} );
			pm.off('.MVDetailPopupMenu')
				.on('mouseleave.MVDetailPopupMenu',function() {
					tb_popup_menu_hide(1000);
				})
				.on('mouseenter.MVDetailPopupMenu',function() {
					tb_popup_menu_cancel_hide();
				})
				.on('mousemove.MVDetailPopupMenu',function() {
					tb_popup_menu_cancel_hide();
				});
			$md_form.off('.MVDetailPopupMenu')
				.on('mouseleave.MVDetailPopupMenu',function(ev) {
					tb_popup_menu_hide(1000);
				});
		}

		const cur_canvas = get_cur_canvas();
		if( cur_canvas ) {
			// console.log({w:'trigger mjsmenuhover',handlers_called_update_menu_count,act,hover_evt});
			cur_canvas.triggerHandler('mjsmenuhover',[act,m,update_menu]);
		}
		if( handlers_called_update_menu_count===0 ) {
			update_menu(act,'direct after tb_hover');
		}
	}


	function open( media_ids, mode, media_ids_idx, superior_media_id_list_cb, done_cb, preview_xopts ) {
		const details2_state = {
			media_ids,
			mode,
			media_ids_idx,
			preview_xopts
		};
		MVDetail.open2(details2_state,superior_media_id_list_cb,done_cb);
	}


	function open2_raw( state, superior_media_id_list_cb, done_cb ) {
		const media_ids = state.media_ids;
		let mode = state.mode;
		const media_ids_idx = state.media_ids_idx;
		const preview_xopts = state.preview_xopts;

		if( m_open_close_transition_active ) {
			return;
		}
		m_open_close_transition_active = true;

		$('.ctx-menu:visible').parent('div').hide();

		if( !m_toolbar_ot_init_done ) {
			m_toolbar_ot_init_done = true;
			// one time initializations..
			$('#md-toolbar .buttons, #md-annotations-toolbar .buttons')
				.on( 'mouseenter', '.icon', function(e) {
					const act = $(this).attr('class').substr(4).split(' ',2);
					tb_hover( this, act[0].substr(0,act[0].length-2), e );
				})
				.on( 'mouseleave', '.icon', function(e) {
					tb_popup_menu_hide(1000);
				})
				.on( 'click', '.icon', function(e) {
					const act = $(this).attr('class').substr(4).split(' ',2);
					tb_click( e, act[0].substr(0,act[0].length-2), true );
				});
		}

		if( media_ids.length===0 ) return;
		startProgress();

		const $md_form = $('#md-form');
		md_canvas = $('#md-canvas');
		md_annotations_canvas = $('#md-annotations-canvas');
		md_canvases = $('#md-canvas,#md-annotations-canvas');
		// save media ids and options for later use
		// console.log({media_ids_idx,media_ids_json:JSON.stringify(media_ids),media_ids,state,superior_media_id_list_cb});
		m_mids = media_ids;
		m_tmp_mids_b4del_order = {};
		m_redt_count = null;
		if( mode===null ) mode = m_mode; // use current/previous mode
		// reset settings
		if( media_ids_idx == -1 ) {
			// set media_ids_idx to index of previous m_media_id in media_ids list
			m_midx = 0;
			for( var i=0; i<m_mids.length; ++i ) {
				if( m_media_id==m_mids[i] ) {
					m_midx = i;
					break;
				}
			}
		} else {
			m_midx = media_ids_idx || 0;
		}
		if( m_midx < 0 ) m_midx = 0;
		else if( m_midx >= m_mids.length ) m_midx = m_mids.length-1;

		if( superior_media_id_list_cb ) {
			m_superior_media_id_list_cb = function( cb ) {
				if( m_media_id==0 && m_mids.length>0 ) {
					// store current m_media_id
					// -> this is used to detect m_midx after loading further results in superior_media_id_list_cb() ...
					m_media_id = m_mids[m_midx];
				}
				superior_media_id_list_cb( cb, mode );
			};
		} else {
			m_superior_media_id_list_cb = null;
		}

		// save preview xopts
		m_preview_xopts = preview_xopts || {};
		// load html template
		const md_data = $('#md-data');
		MVMediaMetadata.setupMetadataView(
			md_data,
			function() {
				compute_dlg_dimensions();
				const f_contents = $md_form.children().detach(); // remove contents before building dialog
				$md_form.dialog( {
					dynWidth: function() {
						compute_dlg_dimensions();
						return md_dlg_w;
					},
					dynHeight: function() {
						compute_dlg_dimensions();
						return md_dlg_h;
					},
					modal: true, resizable: false,
					closeOnEscape: false,
					beforeClose: function( evt, ui ) {
						if( m_open_close_transition_active ) {
							// cancel any close requests while still in transition
							return false;
						}
					},
					close: function( evt, ui ) {
						if( window.hasOwnProperty('MVMediaMetaBatchProcessing') ) window.MVMediaMetaBatchProcessing.hide(true);

						close_all_edits(md_data);

						try {
							if( window.MValueLists ) MValueLists.Destroy();
						} catch( err ) {
							// ignore exceptions here
						}

						$(document).off('.MVDetail');
						reset_media_upload_widget();
						tb_popup_menu_close();

						m_preview_loader.removePreview();

						// clear data
						m_mids = [];
						m_redt_count = null;
						m_dtinfo = null;
						m_midx = 0;
						m_media_id = 0;
						md_data
							.find('.hasDatepicker').datepicker('hide').datepicker('destroy').end()
							.find('form').remove().end()
							.empty();
						$('#md-acl-info-data').empty();
						$('#md-acl-thumbnail').empty();

						closeDialog($md_form,true);
					},
					open: function(ev, ui) {
						let html_tmp = '';
						html_tmp += '<span id="md-t1nav" class="dlg-nav">';
						html_tmp += '<span id="md-empty-icon" class="dlg-nav-empty"></span>';
						html_tmp += '<span id="md-prev-icon" class="link dlg-nav-prev" tabindex="0" role="button"></span>';
						html_tmp += '<span id="md-next-icon" class="link dlg-nav-next" tabindex="0" role="button"></span>';
						html_tmp += '<span id="md-info" class="link dlg-nav-info" tabindex="0" role="button"></span>';
						html_tmp += '</span>';
						const tabs = [ {
							id: 'nav',
							html: html_tmp
						} ];
						tabs.push( {
							id:		'detail',
							html:	'<span id="md-detail-link" class="link" tabindex="0" role="button">'+mjt('md-id')+' <b id="md-id">1234567</b></span>'
						} );
						if( MPlugins.isRegistered('ui-collabannot-thumb-view') ) { //&& ( mj.role_user || mj.role_manager || mj.role_administrator ) ) {
							tabs.push( {
								id:		'annotations',
								html:	'<span id="md-annotations-link" class="link" tabindex="0" role="button">'+mjt('md-edit-annotations')+'</span>'
							} );
						}
						if( mj.feature_versioning && ( mj.role_versions_user || mj.role_versions_manager ) ) {
							tabs.push( {
								id:		'versions',
								html:	'<span id="md-versions-link" class="link" tabindex="0" role="button">'+mjt('md-edit-versions')+'</span>'
							} );
						}
						if( mj.role_administrator ) {
							tabs.push( {
								id:		'acl',
								html:	'<span id="md-acl-link" class="link" tabindex="0" role="button">'+mjt('md-edit-acl')+'</span>'
							} );
						}
						$md_form.closest('.ui-dialog').find('> .ui-dialog-titlebar > .ui-dialog-title')
							.mjDialogTabs( { tabs:tabs } )
							.mjDialogTabs( 'activate', 'detail' )
							.find('#md-detail-link,#md-info').click( function() {
								switch_mode('detail');
							} ).end()
							.find('#md-annotations-link').click(	 function() {
								switch_mode('annotations');
							} ).end()
							.find('#md-versions-link').click(		 function() {
								switch_mode('versions');
							} ).end()
							.find('#md-acl-link').click(			 function() {
								switch_mode('acl');
							} );
					},
				} )
					.append( f_contents );

				$(document)
					.off('mjswinresize.MVDetail')
					.on('mjswinresize.MVDetail', $.debounce( 250, function(evt,w,h) {
						compute_dlg_dimensions();
						m_resize_handler();
					} ) );

				// init view
				switch_mode( mode, function() {
					// when meta- & auxiliary data loaded...
					stopProgress();
					// show view
					$md_form.show();
					md_canvases.triggerHandler('mjsshow');
					m_open_close_transition_active = false;
					update_dlg_tabs_status();
					if( done_cb ) done_cb();
				} );
			},
			''
		);
	}

	function hide() {
		const $md_form = tb_popup_menu_close();
		$(document).off('.MVDetail');
		closeDialog( $md_form, true );
	}

	function compute_dlg_dimensions() {
		const page = $('#page');
		let pageW = page.width();
		let pageH = page.height();
		// if( !mj.media_page_embed_mode ) {
		pageW -= 10;
		pageH -= 10;
		// }
		md_dlg_w = Math.min( Math.max(pageW,360), 4*1700 );
		md_dlg_h = Math.min( Math.max(pageH,260), 4*1200 );
	}

	function reset_dlg_tabs_status() {
		const node = $('#md-annotations-link');
		if( node.length>0 ) {
			MPlugins.callOnAllPluginsOfType('MediaThumbnailView','resetViewNode',true,'link',node,m_media_id);
		}
	}

	function update_dlg_tabs_status() {
		if( m_media_id && m_dtinfo && m_dtinfo.meta ) {
			const node = $('#md-annotations-link');
			if( node.length>0 ) {
				MPlugins.callOnAllPluginsOfType('MediaThumbnailView','updateViewNode',true,'link',node,m_media_id,m_dtinfo.meta);
			}
		}
	}

	$(document).one('mjsload',function() {
		// listen for meta-change events on a few 'special' meta fields:
		MDMedia.bindMetaChanged( function mvdetail_on_meta_changed( media_ids, meta, trigger_meta_ids ) {

			// NOTE: if m_media_id==0 then dialog is closed !

			if( m_media_id && arr_inArray(m_media_id,media_ids)!=-1 ) {
				// save updated data
				m_dtinfo.meta = mj_deep_extend( {}, meta[m_media_id] || {'-1':[0]} );
				// update data views
				if( m_mode==='detail' || m_mode==='annotations' ) switch_data();
				else if( m_mode==='acl' ) ACLEdit.load_acl(0,0,m_media_id);
				// update further view status infos through plugins ..
				MPlugins.callOnAllPluginsOfType('MediaThumbnailView','queryMediaViewStatus',true,'link',[m_media_id],meta,false);
				update_dlg_tabs_status();
			}
		} );

		// subscribe to plugins state changes
		MPlugins.iterateByType( 'MediaThumbnailView', function(name,plugin) {
			plugin.bindStatusChanged( 'link', function( media_ids, meta ) {
				if( m_media_id && arr_inArray(m_media_id,media_ids)!=-1 ) update_dlg_tabs_status();
			} );
		} );

	});

	return {
		open: open,
		open2: MTemplates.queryDialogHTMLWrappedFn('form_media_detail',open2_raw),
		hide: hide,
	};

}(jQuery,mj); // namespace MVDetail
